import { useForm } from "react-hook-form";
import { AgMuiUn } from "../mui-components/AgAutoComplete";
import LabeledTextField from "../mui-components/LabeledTextField";
import LabeledDateOptionalTimeField from "../mui-components/LabeledDateOptionalTimeField";
import { useSnapshot } from "valtio";
import { cartingStore } from "./cartingStore";
import { configStore, contractsStore, dataListStore, multiSelectListStore } from "../state/CommonState";
import Utils from "../util/Utils";
import { useEffect, useState } from "react";
import { AgMultiSelectWithCheckBoxes } from "../components/AgCustomComponents";
import { getStaticConsolidatorList } from "../StaticData";
import { isArray } from "lodash";
import { AgSelectNewCH } from "../components/AgCustlist";
import Api from "../state/Api";
import { AgUnlocCH } from "../components/AgComponents";

export default function CartingSchedule(props) {
    let setRoutes = props.setRoutes
    let setOpenScheduleModel = props.setOpenScheduleModel
    let routes = props.routes
    useSnapshot(cartingStore)
    useSnapshot(configStore)
    useSnapshot(contractsStore)
    useSnapshot(multiSelectListStore);
    useSnapshot(dataListStore)
    const selectedConsolidatorList = getStaticConsolidatorList();
    const consolidatorListKey = "consolidatorList";
     
    let s = cartingStore.schedule
    const cargoForm = useForm({
        defaultValues: {
            por:s.por,
            pol:s.pol,
            pod:s.pod,
            fpod:s.fpod,
            cutoffpor:s.cutoffpor,
            etdpol:s.etdpol,
            etapod:s.etapod,
            etafpod:s.etafpod,
            vesselname:s.vesselname,
            voyage:s.voyage,
            carrier:s.carrier,
            transittime:s.transittime,
            coloader:s.coloader,
            rep:s.rep,
            stuffing_cutoff:s.stuffing_cutoff
        },
      });
      const {
    control,
    watch,
    register,
    setValue,
    handleSubmit,
    reset,
    clearErrors,
    formState: { errors },
    trigger,
    getFieldState,
    getValues,
  } = cargoForm;
  const pod = watch("pod")
  const fpod = watch("fpod")
  const coloader = watch("coloader")
  const carrier = watch("carrier")
  const formValues = watch();
  const [list, setList] = useState([])
  const [carrierlist, setcarrierList] = useState([])
  useEffect(() => {
    if(contractsStore.current.shipmentType.indexOf("LCL") >= 0){
      if(coloader == "" || !isArray(coloader)){
    let k = []
      if (coloader == ""){
        k = JSON.parse(JSON.stringify(selectedConsolidatorList))
        setValue("coloader",k);
    }else{
        let l = coloader.split(",")
        k = []
        for (let i = 0; i < selectedConsolidatorList.length; i++) {
          for (let j = 0; j < l.length; j++) {
            if(l[j]==selectedConsolidatorList[i]['scacCode']){
              k.push(selectedConsolidatorList[i])
            }
          }
        }
        setValue("coloader",k);
    }
    multiSelectListStore.selectList[consolidatorListKey] =
        selectedConsolidatorList.map(({ consolidatorAbbrName,scacCode }) => ({
          id: consolidatorAbbrName,
          name: consolidatorAbbrName,
          scacCode:scacCode,
          checked: k
            .map((addedConsolidator) => addedConsolidator.consolidatorAbbrName)
            .includes(consolidatorAbbrName),
        }));
    }
    }else{
      if(coloader!=""){
        setValue("coloader","");
      }
    }
  }, [coloader,contractsStore.current]);

  useEffect(() => {
    if(contractsStore.current.shipmentType.indexOf("LCL") == -1){
       if(dataListStore["FCLCarrierList"].length==0){
        Api.getFCLCarrierList();
        }else{
          let l = []
          dataListStore["FCLCarrierList"].map((c) => (
            l.push({
                    label: `${c["Display Name"]} (${c["SCAC code"]})`,
                    value: `${c["SCAC code"]}`
                  })
          ))
          if(JSON.stringify(l)!=JSON.stringify(carrierlist)){
            setcarrierList(l)
          }
        }
    }else{
      if(carrier!=process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE){
        setValue("carrier",process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE);
      }
    }
  }, [carrier,contractsStore.current,dataListStore["FCLCarrierList"]]);
  useEffect(()=>{
    let l = [
                    {
                        lable: "Vessel Name",
                        type: "text",
                        name: "vesselname",
                        rules:{ }
                    },
                    {
                        lable: "Voyage",
                        type: "text",
                        name: "voyage",
                        rules:{}
                    },
                    {
                        lable: "Transit Time",
                        type: "number",
                        name: "transittime",
                        rules:{}
                    },
                    {
                        lable: "Stuffing Cut-Off",
                        type: "date-optional-time",
                        name: "stuffing_cutoff",
                        rules:{  }
                    },
                    {
                        lable: "Cut-Off POR",
                        type: "date",
                        name: "cutoffpor",
                        rules:{  }
                    },
                    {
                        lable: "ETD@POL",
                        type: "date",
                        name: "etdpol",
                        rules:{}
                    },
                    {
                        lable: "ETA@POD",
                        type: "date",
                        name: "etapod",
                        rules:{ }
                    }
                    ]
      if(pod!=fpod){
        l.push({
                        lable: "ETA@FPOD",
                        type: "date",
                        name: "etafpod",
                        rules:{  }
                    })
      }
      if(JSON.stringify(list)!=JSON.stringify(l)){
        setList(l)
      }
  },[pod,fpod])
const onSubmit = (data) => {
  let v = true
  if(contractsStore.current.shipmentType.indexOf("LCL") >= 0 && !getvaild("rep")){
    configStore.setModalMessage(`Please check the fields`);
    v=false
  }
  if(v){
  let coloader = []
  if(isArray(data.coloader)){
    for (let i = 0; i < data.coloader.length; i++) {
      coloader.push(data.coloader[i]['scacCode'])
    }
    coloader = coloader.join(',')
  }
    s.por=data.por
    s.pol=data.pol
    s.pod=data.pod
    s.fpod=data.fpod
    s.cutoffpor=data.cutoffpor
    s.etdpol=data.etdpol
    s.etapod=data.etapod
    s.etafpod=data.etafpod
    s.vesselname=data.vesselname
    s.voyage=data.voyage
    s.carrier=data.carrier
    s.transittime=data.transittime
    s.coloader=coloader
    s.rep = data.rep
    let sc = []
    if(contractsStore.current.shipmentType.indexOf("LCL") >= 0){
        sc.push(
            {
                "POR (CFS / ICD / PORT)": data.por,
                "POL": data.pol,
                "POD UNLOC": Utils.getUNCodeFromLocationString(data.pod),
                "ETD (POL)": data.etdpol,
                "ETA (POD)": data.etapod,
                "VESSEL NAME": data.vesselname,
                "VOYAGE": data.voyage,
                "CARRIER": data.carrier,
                "CO-LOADER": coloader,
                "por": data.por,
                "pol": data.pol,
                "rep": null,
                "pod": data.pod,
                "fpod": data.fpod,
                "cutoffpor": data.cutoffpor,
                "etdpol": data.etdpol,
                "etdrw": 0,
                "etarw": 0,
                "etapod": data.etapod,
                "etafpod": data.etafpod,
                "transitTime": data.transittime,
                "rep":data.rep,
                "stuffing_cutoff":data.stuffing_cutoff
            }
        )
    }else{
        sc.push(
            {
                "cutoffpor": data.cutoffpor,
                "etdpor": 0,
                "etdpol": data.etdpol,
                "etapod": data.etapod,
                "etdpod": 0,
                "etafpod": data.etafpod,
                "CARRIER": data.carrier,
                "por": data.por,
                "pol": data.pol,
                "pod": data.pod,
                "fpod": data.fpod,
                "oetd": data.etdpol,
                "deta": data.etapod,
                "v1name": data.vesselname,
                "s1voy": data.voyage,
                "r1code": "",
                "transitTime": data.transittime,
                "ts1code": "",
                "ts2code": "",
                "cscac": data.carrier,
                "CO-LOADER":coloader
            }
        )
    }
    routes[0]['dummyContract']['schedules'] = sc
    contractsStore.current.schedules = sc
    if(data.carrier.length>0){
      routes[0]['dummyContract']['scac'] = data.carrier
      contractsStore.current.scac = data.carrier
    }
    setRoutes(routes)
    setOpenScheduleModel(false)
    }
}

const getvaild = (name) =>{
      if(formValues[name]==undefined || formValues[name].length==0){
          return true
      }else{
        let k = Utils.getUNCodeFromLocationString(formValues[name])
        if((k.length == 5 && /^[A-Z]+$/.test(k))){
          return true
        }else{
          return false
        }
      }
  }

    return(
        <>
        <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px]">
            <div className="columns is-vcentered is-multiline qoutecard">
                <div className="column is-3">  
                    <p className="text-xs font-bold" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR }}>Select POR *</p>
                    <AgMuiUn disabled={true} getValues={getValues} clearErrors={clearErrors} trigger={trigger} validateAddress={true} getFieldState={getFieldState} placeholder="POR" key={"por"} rules={{ required: "POR is Required" }} isDoor={false} control={control} name="por"  />
                </div>
                <div className="column is-3">  
                    <p className="text-xs font-bold" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR }}>Select POL *</p>
                    <AgMuiUn disabled={true} getValues={getValues} clearErrors={clearErrors} trigger={trigger} validateAddress={true} getFieldState={getFieldState} placeholder="POL" key={"pol"} rules={{ required: "POL is Required" }} isDoor={false} control={control} name="pol"  />
                </div>
                {
                  (contractsStore.current.shipmentType.indexOf("LCL") >= 0)?<div className="column is-3">  
                  <AgUnlocCH
                                  isDisabled= {true}
                                    shipmentType={"LCL"}
                                    label="Select Routing"
                                    name="rep"
                                    callback={(e1) => {
                                      setValue(`rep`, e1);
                                    }}
                                    value={formValues["rep"]}
                                    isValid={getvaild('rep')}
                                    />
                </div>:""
                }
                <div className="column is-3">    
                    <p className="text-xs font-bold" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR }}>Select POD *</p>
                    <AgMuiUn disabled={true} getValues={getValues} clearErrors={clearErrors} trigger={trigger} validateAddress={true} getFieldState={getFieldState} placeholder="POD" key={"pod"} rules={{ required: "POD is Required" }} isDoor={false} control={control} name="pod"  />
                </div>
                <div className="column is-3">   
                    <p className="text-xs font-bold" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR }}>Select FPOD *</p>
                    <AgMuiUn disabled={true} getValues={getValues} clearErrors={clearErrors} trigger={trigger} validateAddress={true} getFieldState={getFieldState} placeholder="FPOD" key={"fpod"} rules={{ required: "FPOD is Required" }} isDoor={false} control={control} name="fpod"  />
                </div>
                {list.map((e) => {
                    return (
                        <div className="column is-3">
                        {e.type == "date-optional-time" ? <LabeledDateOptionalTimeField
                            labelStyle={{
                            fontSize: "12px",
                            color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                            fontWeight: "bold",
                            }}
                            label={e.lable}
                            control={control}
                            name={e.name}
                            rules={e.rules}
                        /> :
                        <LabeledTextField
                            labelStyle={{
                            fontSize: "12px",
                            color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                            fontWeight: "bold",
                            }}
                            label={e.lable}
                            control={control}
                            name={e.name}
                            type={e.type}
                            size="small"
                            fullWidth
                            rules={e.rules}
                        />}
                        </div>
                    );
                    })}
                    {
                      (contractsStore.current.shipmentType.indexOf("LCL") >= 0)?<div className="column is-3">   
                      <AgMultiSelectWithCheckBoxes
                  label={"Consolidator"}
                  storeKey={consolidatorListKey}
                  callback={() => {
                    setValue("coloader",
                      multiSelectListStore.selectList[consolidatorListKey]
                        .filter(({ checked }) => checked)
                        .map(({ id }) =>
                          selectedConsolidatorList.find(
                            ({ consolidatorAbbrName }) =>
                              consolidatorAbbrName === id
                          )
                        ))
                  }}
                  withAllShortcut></AgMultiSelectWithCheckBoxes>
                </div>:<div className="column is-3">
                                <AgSelectNewCH
                                  label="Carrier"
                                  name="carrier"
                                  dataList={carrierlist}
                                  callback={(e1) => {
                                    setValue(`carrier`, e1);
                                  }}
                                  value={carrier}
                                />
                              </div>
                    }
            </div>
            <div className="columns is-vcentered is-multiline">
<div className="column is-12" style={{textAlign:"right"}}>
    <div
                    className="field is-grouped"
                    style={{ display: "flex", justifyContent: "flex-start" }}
                  >
                    <div className="control">
                      <button
                        className="button"
                        style={{
                          backgroundColor:
                            process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                          color: "#fff",
                        }}
                        onClick={async (e) => {
                          const isValid = await trigger();
                      if (isValid) {
                        handleSubmit(onSubmit)();
                      } else {
                        configStore.setModalMessage(`Please check the fields`);
                      }
                        }}
                      >
                        Save
                      </button>
                    </div>
                    <div className="control">
                      <button
                        class="button is-danger"
                        onClick={() => {
                          setOpenScheduleModel(false)
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
</div>
            </div>
        </div>
        </>
    )
}